import React from 'react';

const Home = ({ width = '16', height = '12', fill = 'none', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 12"
    fill={fill}
    {...props}
  >
    <path
      d="M15.6642 5.50007C15.6642 5.88679 15.3774 6.18758 15.0522 6.18758H14.4402L14.4593 9.62512C14.4593 9.68958 14.4593 9.75403 14.4593 9.797V10.1408C14.4593 10.6349 14.1151 11.0001 13.6943 11.0001H13.3883C13.35 11.0001 13.3309 11.0001 13.3118 11.0001C13.2927 11.0001 13.2544 11.0001 13.2353 11.0001H12.1642C11.7244 11.0001 11.3992 10.6349 11.3992 10.1408V8.2501C11.3992 7.88487 11.1123 7.5626 10.7872 7.5626H9.56316C9.2189 7.5626 8.95114 7.88487 8.95114 8.2501V10.1408C8.95114 10.6349 8.60688 11.0001 8.18611 11.0001H7.11508C7.07682 11.0001 7.0577 11.0001 7.01945 11.0001C7.00032 11.0001 6.9812 11.0001 6.96207 11.0001H6.65606C6.21617 11.0001 5.89103 10.6349 5.89103 10.1408V7.73447C5.89103 7.73447 5.89103 7.71299 5.89103 7.6915V6.18758H5.27901C4.93475 6.18758 4.66699 5.88679 4.66699 5.50007C4.66699 5.30671 4.72437 5.13483 4.85825 4.98444L9.75442 0.171877C9.8883 0.0214846 10.0413 0 10.1752 0C10.3091 0 10.4621 0.0429693 10.5768 0.150393L15.4539 4.98444C15.6069 5.13483 15.6834 5.30671 15.6642 5.50007Z"
      fill="#717171"
    />
    <path
      d="M4.63709 1.334L4.63675 1.334C3.6085 1.33164 2.61641 1.71319 1.85472 2.40393C1.09304 3.09468 0.616615 4.04486 0.518746 5.06844C0.420877 6.09202 0.708608 7.11527 1.3256 7.93784C1.85853 8.64833 2.60396 9.1649 3.4481 9.41654V10.3133C3.4481 10.6282 3.57321 10.9303 3.79591 11.153L4.14946 10.7994L3.79591 11.153C4.01861 11.3757 4.32066 11.5008 4.63561 11.5008C4.95055 11.5008 5.2526 11.3757 5.4753 11.153C5.698 10.9303 5.82311 10.6282 5.82311 10.3133V9.41454C6.66368 9.15965 7.40496 8.6419 7.93448 7.93206C8.54734 7.11051 8.83274 6.0904 8.73518 5.0701C8.63763 4.04979 8.16409 3.10224 7.40666 2.41172C6.64922 1.72119 5.66204 1.33705 4.63709 1.334Z"
      fill="#717171"
      stroke="#FAFAFA"
    />
  </svg>
);

export default Home;
